import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Chip from 'Chip';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { rel } from '@ifeng-fe/container_channel/common/client/utils/rel';
import styles from './index.css';

/**
 * 定义 Logo 组件
 */
class Logo extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    /**
     * 渲染组件
     */
    render() {
        const {
            content: { logo, subLogo },
        } = this.props;

        return (
            <Fragment>
                <a href={logo.url} target="_blank" rel={rel} className={styles.logoLink}>
                    <Chip id="30005" type="struct" title="港股Logo" groupName="头部" content={logo}>
                        <img src={logo.src} alt={logo.title} width={logo.width} height={logo.height} />
                    </Chip>
                </a>
                <a href={subLogo.url} target="_blank" rel={rel} className={`${styles.logoLink} ${styles.subLogo}`}>
                    <Chip id="80042" type="struct" title="港股子Logo" groupName="头部" content={subLogo}>
                        <img src={subLogo.src} alt={subLogo.title} width={subLogo.width} height={subLogo.height} />
                    </Chip>
                </a>
            </Fragment>
        );
    }
}

export default errorBoundary(Logo);
